import React from 'react';
import { Checkbox, FormControlLabel, Typography } from '@material-ui/core';
import SectionCard from './SectionCard';

const AutoUpdateCheckbox = ({ form, setForm }) => {
    return (
        <SectionCard icon="system_update_alt" title="Auto Update">
            <FormControlLabel
                control={
                    <Checkbox
                        checked={form?.autoUpdate || false}
                        onChange={event => {
                            const newValue = event.target.checked;
                            setForm(prevForm => ({
                                ...prevForm,
                                autoUpdate: newValue
                            }));
                        }}
                        name="autoUpdate"
                        color="primary"
                    />
                }
                label="Enable Automatic Cluster Update"
            />
            <Typography variant="caption" color="textSecondary" display="block" style={{ marginLeft: 32 }}>
                Automatically update this cluster when Heidi is updated to a new version.
            </Typography>
        </SectionCard>
    );
};

export default AutoUpdateCheckbox;
